import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding-bottom: 8px;
`;

export const Content = styled.div`
  background: #fff;
  width: 100%;
`;

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const SearchResult = styled.div`
  height: 410px;
  display: flex;
  flex-direction: column;
  padding: 4px 24px;
  overflow-y: auto;
`;

export const EmptySearchResult = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 32px;
  font-weight: 400;
  font-size: 0.75em;
  line-height: 1em;
  color: ${Palette.PrimaryGray._700};
`;

export const Item = styled.div`
  ${highlightStyle}
  color: ${Palette.PrimaryGray._700};
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.25em;
  padding: 6px;
  margin-top: 8px;
  border: 1px solid #ffffff;
  height: 36px;
  display: flex;
  align-items: center;
  &:hover {
    background: ${Palette.PrimaryGray._100};
    border: 1px solid #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
  &:active {
    background: ${Palette.Primary._000};
    border: 1px solid ${Palette.Primary._300};
    border-radius: 4px;
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  &:hover {
    background: ${Palette.PrimaryGray._100};
  }
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  padding-left: 24px;
  width: 100%;
  height: 36px;
  /* margin-top: 8px;
    margin-bottom: 8px; */
`;

export const GroupName = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
  ${highlightStyle}
  margin-left: 8px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ItemsGroup = styled.div`
  margin-top: 8px;
`;
